<template>
  <div class="box3">
    <div class="box3-wrapper">
      <pageTitle title="用户规模迅速增长 占领互联网流量高地" tit="短视频正逐渐渗透至生活全场景，成为内容传播渠道标配" titleColor="#000" titColor="#333" />

      <div class="content common-animation">
        <div class="left-btn" @click="prevPage"></div>
        <div class="right-btn" @click="nextPage"></div>
        <!-- 讲师信息 -->
        <el-carousel :autoplay="isAutoPlay" :loop="true" :arrow="'never'" :initial-index="0" :interval="3000"
          ref="carousel" type="card" height="400px;">
          <el-carousel-item v-for="(item, index) in teacherList" :key="index">

            <div class="item-img" :style="`background-image: url(` +
              require(`@/assets/topic-page/newMedia2/box3/img0${index + 1}.jpg`) +
              `)`
              "></div>
            <div class="item-info">
              <p class="info-content" v-html="item.content"></p>
              <div class="source">{{ item.source }}</div>

            </div>

          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="btn" @click="childMethod">了解就业前景</div>
    </div>
    <img class="img-bottom" src="../../../assets/topic-page/newMedia2/box3/img-bottom.jpg" />
  </div>
</template>

<script>
import pageTitle from "../../../components/common/pageTitle.vue";
export default {
  components: {
    pageTitle
  },
  data() {
    return {
      isAutoPlay: true,
      timer: null,

      realIndex: 0, //选中的讲师
      initialWidth: 0, //初始样式
      initialLeft: 0, //滚动条初始位置
      isClick: false, // 点击滚动条后才能拖动

      teacherList: [
        {
          content: "2023年3月，中国互联网络信息中心（CNNIC）发布第51次《中国互联网络发展状况统计报告》。<br/>《报告》显示，短视频用户规模达<i>10.12亿</i>，用户规模占整体网民<i>94.8%</i>。<br/>Mob研究院调研显示，短视频已成为吸引网民的首要渠道，人均每天刷近3小时。",
          source: '数据来源：中国互联网络信息中心、Mob研究院《2023年短视频行业研究报告》'
        },
        {
          content: "字节投资报告显示，2023年抖音电商618总销售额同比增长<i>72.74%</i>，<br/>其中直播带货销售额占比81.39%，同比增长<i>68.83%</i>。",
          source: '数据来源：字节跳动投资报告Mob研究院《2023年短视频行业研究报告》 '
        },
        {
          content: "“东方甄选”直播间，618累计销售额破<i>3亿</i>；<br/>某知名主播<i>一场直播带货销售额几千万</i>；<br/>短视频、直播的带货变现能力让人大开眼界！",
          source: ''
        }
      ]
    };
  },
  methods: {
    prevPage() {
      // this.$refs.carousel.autoplay = false;
      this.$refs.carousel.prev();
      this.isAutoPlay = false;
      this.timer = setTimeout(() => {
        this.isAutoPlay = true;
      }, 500);
    },
    nextPage() {
      this.$refs.carousel.next();
      this.isAutoPlay = false;
      // this.$refs.carousel.autoplay = false;
      this.timer = setTimeout(() => {
        this.isAutoPlay = true;
      }, 500);
    },
    beforeDestroy() {
      clearTimeout(this.timer);
    },
    childMethod() {
      this.$parent.itcastClick();
    }
  }
};
</script>

<style lang="scss" scoped>
.box3 {
  margin: 0 auto;
  .btn{
      width: 207px;
      height: 56px;
      font-size: 20px;
      color: #fff;
      text-align: center;
      line-height: 56px;
      border-radius: 28px;
      font-weight: bold;
      box-sizing: border-box;
      box-shadow: 0 8px 7px #e2b8db;
      background: url("../../../assets/topic-page/newMedia2/btnbg1.png") no-repeat;
      cursor: pointer;
      margin: 0 auto;
      padding-right: 20px;
      &:hover{
        box-shadow: none;
      }
    }
  .box3-wrapper {
    margin: 0 auto;
    padding: 80px 0px 60px;
    max-width: 2048px;
    background: url("../../../assets/topic-page/newMedia2/box3/bg.jpg") no-repeat;
    background-size: 2400px auto;
    background-position: center;
  }
}

.img-bottom {
  width: 100%;
}

::v-deep.el-carousel--horizontal {
  overflow-x: hidden;
  padding: 40px 0px;
}

::v-deep .el-carousel__container {
  position: relative;
  height: 400px;
}

.content {
  position: relative;
  margin: 0 auto;

  width: 1200px;

  .left-btn {
    position: absolute;
    top: 44%;
    left: -33px;
    width: 50px;
    height: 50px;

    background-image: url("../../../assets/topic-page/newMedia2/box3/icon-left.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    cursor: pointer;
    z-index: 9;

    &:hover {

      background-image: url("../../../assets/topic-page/newMedia2/box3/icon-left-hover.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
    }
  }

  .right-btn {
    position: absolute;
    top: 44%;
    right: -33px;
    width: 50px;
    height: 50px;

    background-image: url("../../../assets/topic-page/newMedia2/box3/icon-right.png");
    background-repeat: no-repeat;
    cursor: pointer;
    background-size: 100% 100%;
    background-position: center;
    z-index: 9;

    &:hover {

      background-image: url("../../../assets/topic-page/newMedia2/box3/icon-right-hover.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
    }
  }

  .item-img {
    position: relative;
    margin-right: 60px;

    width: 320px;

    height: 326px;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 8px;
    overflow: hidden;
    z-index: 3;
  }




}

.el-carousel__item {
  display: flex;
  align-items: center;
  padding-left: 30px;
  padding-right: 30px;
  // height: 365px;
  box-shadow: 0px 0px 40px 0px #ffeae5;
  border-radius: 20px;
  background: #fff;
  opacity: 0;
  // opacity: 1;
  box-sizing: border-box;

  .item-info {

    flex: 1;

    .info-content {
      font-family: PingFang-SC-Regular;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 34px;
      letter-spacing: 0px;
      color: #263427;
      display: inline;

      ::v-deep i {
        font-size: 22px;
        color: #ff3478;
        font-style: normal;
      }

    }

    .source {
      margin-top: 20px;
      font-family: PingFang-SC-Regular;
      font-size: 14px;
      color: #999999;
    }
  }

  // .item-img {
  //   min-width: 90px;
  // }
}

.el-carousel__item.is-in-stage {
  opacity: 0.5;

  .item-info {
    margin-left: -307px;
    flex: 1
  }
}

.el-carousel__item.is-active {
  opacity: 1;
  transform: translateX(100px) scale(1) !important;
  width: 980px;
  height: 400px;
  // background: #ffffff;
  background-color: #ffffff;
  box-shadow: 0px 0px 40px 0px #ffeae5;
  border-radius: 20px;
  cursor: pointer;

  .item-info {
    margin-left: 0px;
    flex: 1
  }

  .item-img {
    width: 440px;
    height: 326px;
    background-color: #e0edff;
    border-radius: 10px;
  }
}

::v-deep.el-carousel__indicators {
  display: none;
}
</style>